import { render } from "./newuserSvg.vue?vue&type=template&id=1842ac62"
import script from "./newuserSvg.vue?vue&type=script&lang=js"
export * from "./newuserSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__